import { render } from "./ContractRegisterId.vue?vue&type=template&id=8af41bda&scoped=true&ts=true"
import script from "./ContractRegisterId.vue?vue&type=script&lang=ts"
export * from "./ContractRegisterId.vue?vue&type=script&lang=ts"

import "./ContractRegisterId.vue?vue&type=style&index=0&id=8af41bda&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af41bda"]])

export default __exports__